import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => ({
  navHeader: {
    backgroundColor: theme.palette.primary.main,
  },
}));

export default styles;
